export const getSanitizedStatement = (statement?: string): string => {
    return statement?.replace(/\D/g, '') || '';
};
